module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAaBAMAAABFrWFOAAAAIVBMVEXV3OTV3OTV3OTV3OTV3OTt8PPk6O3p7fDe5OrZ3+fl6e5EVCNdAAAABHRSTlPm50pJ6bzg4AAAADtJREFUGNNjMHCBAmYGFhjTgcEFDqjEdEMwXSsRzNAWKDM0NDQMwQxdghBFVotpghu1HCmC8LwCjCkEACEfRjCoq/uCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_after1.png
// module id = z12p
// module chunks = 9